import React from "react"
import "./svg.css"

function Svg() {
  return (
    <svg
      id="Lager_1"
      className="svg-map"
      data-name="Lager 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 408.01 418.65"
    >
      <defs></defs>
      <a href="/italy">
        <path
          className="cls-1 italy active"
          d="M2460.23,766.21l-3.93,10,2.67,3.3-1.41,5.5h-6l-2.51-3.3h-3.3l-3.62-1.88-6-3.3-2.83-.16s-1.57-.31-1.57-1.1-.31-3-.31-3v-2.67h2.35c1,.47,1.26,1.1,1.73.63S2437,769,2437,769l1.1-1.25,2.2.78,2,1.89h4.24l3.3-.79,4.09-2.35,1.72.62,1.73-.62Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <a href="/france">
        <path
          className="cls-1 france active"
          d="M2399.26,732.26l-3.77-.78a6.39,6.39,0,0,1-.47-1.57,11.62,11.62,0,0,0-.32-1.73l.32-1.42-1.1-.94-.32-1.26.16-5.18s1.73-1.26,2.2-1.73a11.89,11.89,0,0,1,2.2-1.26l1.42.47.47-3,1.73.47v5s.31,2.36.31,3-.79,6.45-.79,6.45Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <a href="/italy">
        <path
          className="cls-1 italy active"
          d="M2390.46,738.39l-.47,3.3,3.3,5.34s-.47,1.26-.16,1.73a17.29,17.29,0,0,1,.95,2.2s-2,3-1.73,4.09.94,5.5.94,5.5l2.2.47c.79.16,2,.47,2,.47l.32-2.83h3.3s.31.79.78,0,1.89-6.91,2.05-7.54,1.1-4.71.78-5.19a18.37,18.37,0,0,1-.94-2.35l.31-1.73-1.57-3.93-2.83-3.3-6.91,4.87Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-2"
        d="M2256.26,592.25s-3.61-2.83-3.45-2.2a11.27,11.27,0,0,1,.15,1.89s1.58,0,1.89.47.94,1.1.47,1.26,1.42.15-.47.15a5,5,0,0,0-2.36.32s-.63-.16,0,.63,1.1,1.25,1.1,1.25l.79.63.94.94-1.1.63,1.42.47h1.25l-.78,1.26.63.47h8.17l1.25-.94a8.52,8.52,0,0,0,2.05,0c.47-.16,5.18-3,5.18-3s6.44,1,7.07.48,6.13-6.92,6.13-7.39-.16-6.91-.16-7.54.16-4.72.16-4.72l.32-2h1.57l1.25-1.1,1.58-.94,1.57-.63.63-2.2-2.52-1.89v-1.88l-1.1-3-.78-1.73-2.52-.15-4.08.94.62-1.89-2.51.47-1.1.79-.47-1.73-3.3.16-2,2.83-1.73.94-.16,1.1,2.36,1.57s1.57.47.15.94-3.3,1-3.3,1l-.15,1.1-2.2.78-.95-.63-2,.95-.63-2.52a11.19,11.19,0,0,0-2.2-.31h-2.67l.79,1.26s-1.42-.16-1.57.47-.32,1.1-.32,1.1l.47.78,1.26.32s1.1.31,1.26.94a13.87,13.87,0,0,0,.47,1.41,13.23,13.23,0,0,0-2.51,1.1c-.63.48-1.58,1.26-1.58,1.26l.63,1.42.32,1.25,1.25-.47h1.26l.63,1.73,3.14.31.16,1.58a.81.81,0,0,0-1.1,0,3.9,3.9,0,0,1-1.41.62l-1-.15-1.41,3.61-1.26.32-1.1.47a3.84,3.84,0,0,0,1.57.63c.63,0,3.93-.16,3.93-.16l1.57.47s0,1.1-1.41,1.1H2261l-1.42-.47-1.41.78Z"
        transform="translate(-2223.59 -372.99)"
      />
      <a href="/uk">
        <path
          className="cls-1 uk active"
          d="M2282.19,621.48l.79,1.1,1.25.31.79,1.42.63.16,1.1-2.05s1.1-1.73,2-1.73,1.26-.31,2-.31,5.66,2.51,5.66,2.51l2.36-.78.16-2.83h4.55c.47,0,5.19,1.26,5.19,1.26l2.36-.47a3.8,3.8,0,0,1,2.2-.48c1.57,0,6.75.32,6.75.32l4.4-.47s1.73.47,2.52.63a19.62,19.62,0,0,0,5.34-.32c.47-.31,5-1.26,5-2.36s.16-3.3.16-3.3l-3-.78-3.46-.63v-.79l2.67-.31.32-1.26-.47-1.25,2.35-.48,2.2-1.57,1.73-1.41,1.1-5.19-1.88-3.45s-1.26-1.42-1.89-1.42-3.3-.16-3.3-.16l-3.61,1.42-.47-2,1.41-2.68a1.27,1.27,0,0,0,0-1.57,10,10,0,0,1-1.73-2.35c-.16-.63-2.83-2-2.83-2s.16-1.1.63-1.1a2.75,2.75,0,0,1,1.57.16c.47.31,1.89,1.41,1.89.94v-1.88l-1.1-1.89-.79-2.51-2.83-4.25-1.88-.47-1.1-2.83-2.2-10-5.19-5.66-2.35.47-1.42.47-2-.47s-1.42-1.26-.94-1.26a20.36,20.36,0,0,0,2.35-.47l3.62-1.1,1.41-.78-.31-1.26-.95-.31,3.15-1.89s3-6.76,3.61-7.23,1.89-1.88,1.89-2.36a8.56,8.56,0,0,0-.63-1.88l-4.72-1.57-4.71-.94a12.89,12.89,0,0,1-2.83,1.57,22.85,22.85,0,0,1-3.3.47s-.63-.16,0-.63a9.81,9.81,0,0,1,1.26-.79l1.41-1.25.32-.63s-.79,0-.79-.47a1.93,1.93,0,0,1,.94-1.42,9.66,9.66,0,0,1,2-.94l2.67-2.67,1.26-2.67-.48-1-.62-.15a4.08,4.08,0,0,1-1.73.63c-1.1.15-4.72.15-4.72.15l-1.73-.63-1.1-1.25-1.25.31-.32,3.77-1.73.16s-.47-.47-.62,0-.48,1.26-.48,1.26l.48,2s.47.79,0,.79-3.62.15-3.62.15l-.31,3h-1.26l.47.78.94,1.42v1.88s.16.63-.47.63-.78-.31-1.25-.63a7.53,7.53,0,0,1-1.26-1.41l-.94-.94v-2.83h-1.26v1.41h-1.57v1.26l1.57,1.26.94.94.32,1.26,1.25.63,1.57.94-1.25,2.2h-1.89a.6.6,0,0,0,0,.78c.32.47,1.57,2.05,1.57,2.05h1.73l.16,1.1-.63,2.51-3.61,9.27,2,.16,1.88-6s0,.63,1.26.63a3.32,3.32,0,0,0,1.73-.32,7.6,7.6,0,0,1-.16,3l-.47,1.57.94,1.1-5,7.54.94,1.89.94-1.1,1.73,1.41s.63,1.1,1.1.47-.16-1.88.63-1.88a13.44,13.44,0,0,1,2.67.63,1.92,1.92,0,0,0,1.41.31,11.24,11.24,0,0,0,2.68-1.73l2,.63-.47,1.57-3.3,2.36,1.88,6.91,3.93-2-1.57,3.14-.47.79v3.14l-1.73.16-.31,2.51-.32,1.73-2-.94s.16-.16-.94-.16a22.45,22.45,0,0,1-3.3,0,29.16,29.16,0,0,1-3.46-2l-.94.78,1.25,1.89s.79,1.73,0,1.73-1.41-.32-1.88.31-1.1,1.57-1.1,1.57l1.57.16h2.2l.47.63v1.57l-.47,4.09-9.9,4.24v1.41a3.5,3.5,0,0,0,.63.79l.47.47,3,.16,3.3-1.1a2.49,2.49,0,0,1-.15,1.41l-.32.63,1.89,1.26a5.47,5.47,0,0,1,1.57.16l.47,1.25,1.89,1.26a3,3,0,0,0,1.73,0c.62-.31,2-1.26,2-1.26l2.36-1.57.15.79-1.25,1.25-1.42,2.52s.79.63-2.2,0a41,41,0,0,0-5.18-.94h-2.2l-.32,1.41s.79,1.73,0,1.73h-3.46s-.78,3-1.41,3.14.16.47-1.73,1.1a8.94,8.94,0,0,0-3.46,2.67Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-2"
        d="M2402.82,566.22l-2.41.63-.52.63s-.21,1.67.1,2.09a25.45,25.45,0,0,0,1.89,1.78l3.46,1.57.73-2.3s1.26-.21,0-2.2-1.57-2.41-1.57-2.41Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2411.41,561.09l-1.25.52v1.26l-1.26,1-2.31.32s.21,1.26.53,1.36,1.67.73,1.67.73l.21,2.73,2.1,1,1.78,1.47,1.57,1.05s1.36.42,1.36-.11a12,12,0,0,0-.62-2.2l1.67-.94s.73-.1.73-.73a2.5,2.5,0,0,0-.31-1.15l-.94-1,.31-1.57,1-.94-.31-3.77a6.45,6.45,0,0,1-1.68-.32c-.32-.21-2.1-.63-2.1-.21s-.21,2.94-.21,3.36.53,1.57,0,1.57-1.25,0-1.25-.53.1.42,0-.52A13.26,13.26,0,0,0,2411.41,561.09Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1  active"
        d="M2446.09,541.91,2445,543l-.94,6.92-1,5.44s.94.32,1.15-.1,1.16-3.46,1.16-3.46,1.25-4.92,1.25-5.34S2446.09,541.91,2446.09,541.91Z"
        transform="translate(-2223.59 -372.99)"
      />

      <a href="/sweden">
        <path
          className="cls-1 sweden active"
          d="M2454.89,534.37l-1.36,2s-1.36,1.36-1.36,1.68.52,2.72.52,2.72l.63,2.73,1.88,1.25a27.4,27.4,0,0,0,1.89-3.56c0-.42-.11-1.88-.21-2.62s-.11-3-.11-3.35.84-.94.84-.94l-2.3-1.37Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-2"
        d="M2481.39,521.8l-1.46-.84h-1.57l-1.37.53-3.14,1.57-.42.84s.11,1.36.53,1.46,1.67.53,1.67.53.63,0,.63.31v1.15l-.73,2s.94.42,1.15.11a4.26,4.26,0,0,0,.42-1.47c.1-.63.42-2.09.42-2.09l2.41-1.26s.63-1.78,1.15-1.78,1.26.31,1.47-.11.62-.52.31-.84-.94-1.15-.94-1.15Z"
        transform="translate(-2223.59 -372.99)"
      />
      <a href="/spain">
        <polygon
          className="cls-1 spain active"
          points="112.19 379.07 113.13 380.8 116.12 380.8 118.32 382.69 121.78 379.07 120.36 377.81 119.89 375.46 112.19 379.07"
        />
      </a>
      <a href="/spain">
        <polygon
          className="cls-1 spain active"
          points="126.8 374.83 126.17 376.09 130.26 377.97 131.83 377.03 129.95 374.67 126.8 374.83"
        />
      </a>
      <a href="/spain">
        <path
          className="cls-1 spain active"
          d="M2326.66,757.09l-2.35,1.26-.48,1.73s.16,1.41.79,1.41,4.56-3.61,4.56-3.61Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-2"
        d="M2543.2,785.85l-.47.94-2,.32v3l9.27-.31,3.3.15.31,1.26,12.42-3,1.41-.16,1.26-3.77h-2l-.63.63-3.3,1.1s-.32,1.88-.79.94-.78-1.42-.78-1.42l-3.3.32-4.25.63-5,.94-2.36-.63Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2229.86,415.05a9.85,9.85,0,0,0,1.26,1.88l6.5.21,2.2,3.57-.53,1.15-1.57.84a1.3,1.3,0,0,1,.84.42c.42.41,1.15,1,1.15,1l-.31,1.16-.42.52-.74.1-2.61-.73-3-1.57-4.19-1.47s-.42,1.89-.11,2.2a8.26,8.26,0,0,0,1.78.84l2.41.42,2.31,2.3s1.05,5.77,1.05,6.19a1.4,1.4,0,0,1-1.37,1h-5.55l-.21,1.68s9,3.35,9,3.67.21,2.51.21,2.82.73,1.26.73,1.26l4,.84a24.41,24.41,0,0,0,2.2,3.56,28.21,28.21,0,0,0,4,.21l2.3-1.47,7.75.74,4.82-3.25,3.35-.63a10,10,0,0,0,1.89,1.47c.31,0,3.46-3.25,4.4-3.67s4.82-1.88,4.82-1.88l.21-3.88s.84-.52.84-1.15a4.67,4.67,0,0,0-1.05-2.52c-.63-.73-1.89-2.09-1.89-2.09l-.1-1.05v-1.57l-.21-.73s-1.05.62.1-1.26.63-1.15.63-1.15l.84-1.26-3.88-.21s.11-1.68-.21-2-1.78-1.57-1.78-1.57l-2.09-.11-1.05,3.46-1.15.1-1.36-1.25a15.84,15.84,0,0,0-1.68.73,6,6,0,0,1-1.36.42l-.32-1.36-.94-2-.94-.11-.42,2.52-.63,3.35a1.16,1.16,0,0,1-.42-.63l-1.46-6.08-2.62.42-1.37,2.41-.73-.1-1.36-3.88s-.21-1.05-.52-.84-1.16.63-1.16.63L2248,423h-.53l-.73-1.68-4.09,3.67s-.52-5.66-.1-5.87,2.2-.41,2.2-.83a32.13,32.13,0,0,1,1.36-3.56l-3.35-6-1.26-.31.32,5.45-4.72-3.67-1.25,1.57.1,3.56-1.57-.52-1-2.1-.73,1.16s.1.73-.74.73A7.36,7.36,0,0,0,2229.86,415.05Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2620.2,639.55a22,22,0,0,1-2.2.79l-1.26.15-1.25,1.58-.63.47-1.73,1.72-.47.48-.71.56a7.09,7.09,0,0,0-1-.56l-1.57-.79-1.42-1.73-.62-.78s1.1.31-1-.32-1.57,0-2-.63l-.47-.63-3.77-.31h-1.73l-1.73-.63s-.47-.63,0-.63h7.23l.78-.31a3.75,3.75,0,0,0,1-1.73l.15-.94,1.73-3c-.47-.94-1.1-2-1.1-2l.79-.94,1.88.94.95-.79v-1.25l1.41-1.26s4.56-1.89,4.56-2.36,2-2.2,3-3a12.57,12.57,0,0,0,1.58-1.57s.94.47.94-.48a16.77,16.77,0,0,0-.16-2l2.67-1.16v-4.81c0-.94,2.83-4.09,2.83-4.09a10.56,10.56,0,0,0,1.26-3.14c0-.94,2.83-2.83,2.83-3.77a11.34,11.34,0,0,1,.31-2.2l-3.46-7.23,1.58-2.83.31-3.14-.94-1.89h-7.55l-2.2,2.2h-5.34l-3.14.63-3.46,1-4.4-1.58-1.88,1.89-11-.63a5.84,5.84,0,0,1-1.26-1.88,16.91,16.91,0,0,0-2.2-3.15l-3.14-.63-4.72.63a19.55,19.55,0,0,1-.94-2.2c-.32-.94-1.89-6.91-1.89-6.91l-.63-1.26-3.45-.94-2.83,1.57-2.2.94-.63,1.57-3.46.32a23.87,23.87,0,0,1-.31,3.77c-.32,1.57-4.09-.94-4.09-.94l-4.92,2.72.68,6.86,1.89,4.09-1.89.47s-4.08-.79-4.56-.79a9.48,9.48,0,0,0-2.2,1.1l-3,.32-.79-1.89-.78-.15-1.1.31v1.1c-.47.47-2.67.47-2.67.47a14.7,14.7,0,0,0-2.2-.16,16,16,0,0,0-3.62.79v.79l-.78,1.57-1.42-.63-3.14-2-4.09-.63-3,.63H2519l-3-.16-1.42.47L2513,594l-6,2.51-1.1,2.2-2.2.16.94,3.3,3,3.77s1.41,5.66,1.41,6.13a4.78,4.78,0,0,1-.78,1.57l-2.52,1.57-2.83,4.4-1.25,4.4v2.68l1.57,2.35.78,1.57-2.35.63-2,.32.63,8.17,3.77,2.36h2.2c1.26,0,3.46.15,4.88,0s4.24-.32,4.24-.32l4.08-.63,1.89,1.26s1.26.78,1.73.31a9.61,9.61,0,0,0,1.26-1.25,25.32,25.32,0,0,1,2.2-2.2l1.41-.79h2.67l2-.38c.12-.31.29-.7.5-1.19l1.88-4.4,5.66-2.51,7.07.78,1.73.47,3.61-.63,2.36.79,1.57,2,1.1,3.77.79.79,2,.63,3.61,5.18,2,1.1.74.63H2569l1.73,1.73.63.79.63-2.68v-1.1s-2.2.32.63-.62-.16.15,2.83-.95l3-1.1.94-3,.16-1,1.42-2.2.31,1.89.31.79,3.62.62s.94.63.47,1,.47,0-.47.31a4.55,4.55,0,0,1-2,.32,29.06,29.06,0,0,0-3,.31v.63l2.83.31.31,1.42,1.26.47,2.36.31,3.61-.15a10.22,10.22,0,0,1,3.3-2l1.42-.15s1.41-1,1.41,0,.79-1.26,0,.94l-.79,2.2-5.65,6.91.63.79h2.2l.78-.47,1.42-.63.94.63,1.26.15h.94l1.88.79s1.26-3.3.79,1.26-1.57,4.08-.47,4.55c2.83,1,1.41,1,2.83,1s2-1.73,2.67-2.2,1.57-1.26,1.57-1.26l.47-2s1.42-1.57,2-1.73,1.58,0,2.05-.63l.47-.63.16-1.57.47-1.26,1.1-.78.63-1.1a10.36,10.36,0,0,1,1.57-.16l2.35-.63,2-1.26a9.39,9.39,0,0,0,.31-2,3.84,3.84,0,0,0,.63-1.57v-1.1A3,3,0,0,0,2620.2,639.55Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2504.57,490.13l.08-.07Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2504.83,489.9l.09-.08Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2504.31,490.35l.09-.07Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2505,489.72l.09-.08Z"
        transform="translate(-2223.59 -372.99)"
      />
      <a href="/finland">
        <path
          className="cls-1 finland active"
          d="M2504.17,490.48l10.12-27.56s-1.89-6-2.83-6-4.4-3.77-4.4-3.77l-4.71-3.77V446s-2.52-5-5.35-7.22l-2.83-2.2v-5.66l-9.11-11.32.94-9.11s-6-5.66-8.17-6.6a3.39,3.39,0,0,1-1.88-3.46l.31-3.77-2.2-2.83.16-4.4-3.3-.94-2.36-2.36-2.36,2.05-3.3,1.88-.31,3.46-1.42,3.3,1.26,1.88-.16,4.72-1.41,3-2.36-1.57-3.61-1.25-.32,1.41a.8.8,0,0,1-.78.94,25.45,25.45,0,0,1-2.83.47c-.63,0-1.57.63-1.88,0a29.77,29.77,0,0,0-1.58-3.14c-.47-.63-2.2-2.67-2.2-2.67l-2.51.63-.63,1.1,1.1.94.32,2.36.78,1.88,8.17,3.15L2456,412l1.1,7.23,1.1.31.47,3.93a6.49,6.49,0,0,0,.94,1.73,27.47,27.47,0,0,1,1.89,3.14v5.35l3.22,4.53.24-.13.62-.47,2.52-.79s.94.16,1.1.63-.16.78.47.94a7.48,7.48,0,0,1,1.26.47l1.1.47.63,2v2.51a5,5,0,0,1,0,1.57c-.16.63-1.42,1.42-1.42,1.42l-.63,1.1,1,2.82-1,3-2,4.4s-2,4.09-2.67,4.4-3,1.1-3.3,1.57a2.32,2.32,0,0,0-.32,1.73,5.11,5.11,0,0,0,.95,1.26v1.1l-.95,1.57-1.72.31-1.89,1.57v3l2.83,6.29,1.88,4.87,1.89.94L2464,493.1l.79,3.92,2,3.15H2470l4.25.78a11,11,0,0,0-1.1,2.36c-.32,1.1-1.1.94-.32,1.1a20.17,20.17,0,0,0,2.67.16l2.36-.32.47,1.1c.95-.15,2.36-.31,2.36-.31l2-.94,1.1-1.73,1.57-1.1,3-.63,1.89-2.52,1.1-1.57a16.62,16.62,0,0,0,2.51-.63,15.4,15.4,0,0,0,4.71-2.82,6.34,6.34,0,0,0,3-.48,25.67,25.67,0,0,0,2.62-2.15Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-1"
        d="M2505.25,489.54"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2476.26,396.61l.94-2.51-1.25-2.83,3.45-3.14v-3.46h-3.77s-.63,2.2-1.57,1.26-4.4-4.09-4.4-4.09l5.34-2.2s-.31-2.2-1.88-2.51-5.35-2.2-7.55-2.52-.62-2.2-3.14-.63l-2.51,1.57s1.41,1.42,1.41,1.89a38.79,38.79,0,0,1-1.1,3.77l-.94.47-1.1-1.41-.63,1.26s-.31,1.88-.47,2.67.16,1.73-.47,1.73-1.57,1.57-1.89,0a13.45,13.45,0,0,1-.31-2.2v-4.09l.16-1.57-1.26-.16-.94.32-1.42,1.41v3.14l-.63,1.89a8.09,8.09,0,0,1-2.67-.16c-.47-.31-.94-.94-1.57-.94a14.25,14.25,0,0,0-2.67.78s-.79.79-.32,1.1a4.65,4.65,0,0,0,1.42.48l1.26.47,1.57.47a3.07,3.07,0,0,0,.15,1.57,5.46,5.46,0,0,1,.32,1.89s-.47.62-.94.62h-1.42a14.11,14.11,0,0,1-2.2-.31h-1.41l-.32.79v1.41l1.89,1.57s-1.73-.47-2.2-.16-1.89.63-1.89,1.26a9.86,9.86,0,0,1-.47,2h-1.1l-.47-2.67c-1.1.16-2.2,0-2.2.47s.47,1.26,0,1.26-1.1.47-1.73-.16-1.1-1.1-1.1-1.1l-.16-.62s-.94.31-.94.94a5,5,0,0,0,.63,1.73s1.57,1.25,1.1,1.25-.79.16-1.57.16-2.52-.31-2.52.16a6.86,6.86,0,0,0,.95,1.88l2.35,1.73a5.14,5.14,0,0,1-2.2.63c-1.1,0-3.61-.31-3.61-.31s-1.1-.47-1.1.15a25.9,25.9,0,0,1-.47,2.83s-.16.79.31.79a10.83,10.83,0,0,1,1.89.47s.16,1.73.16,2.2a2,2,0,0,1-.32.94h-2.83a14.11,14.11,0,0,1-1.25-1.41c-.32-.47-1.58-.63-2.2-.63h-3s1.1,1.26,1.73,1.26h1.57l.79.47-2.2,1.73h-5.19l2.2,1.88s.31-1.1.63.32a1.56,1.56,0,0,0,1.41,1.41l1.1-.63,2.36-1.25.47-.95,3.3-.15,2.67.78-.78,1.42-2.05.94-2.82.63s.78,3.45.15,3.61-3.61.63-3.93,1.1-.78,1.42-.78,1.42l.63.78,2.2-.16-.63.79v1.41l-3.3,1.73s-.32,1.73,0,2.2,1.26.47,1.26.47c.47.79,2,1.58.47,1.89a17.64,17.64,0,0,0-3.3,1.1l-2.67,2.51s-2.05,2.36-2.05,2.83a2.44,2.44,0,0,0,.32,1.73,12.6,12.6,0,0,1,.94,1.57s1.73-.31-.94.47-2.67,2.05-2.67,2.05l1.41,1.73v2l-1.1,1.88V451l.79,1.26s3,.31.31,1.26-4.56,1.41-4.56,1.41l-1.88,1.41v1.1l.94.79-.47,2.51-.79,2.2-1.73.16-1.25-.31-1.73,2.83-.63,2.82s.79,1.1-.47,1.42l-1.26.31s-2-.47-.16.79,2.68,1.73,2.68,1.73l2.82-.32s.16,1.1-.62,1.42-2.83.94-2.83.94h-.95l-1.41-1.26-.16-.94-2.35-.16-.16,1.73-.79,1.26h-.63l-1.1-.16-1.57.94s-.15.16-.15.79-.32,3-.32,3a7.39,7.39,0,0,1-1.88,0c-.48,0-1.1-.16-1.89-.16h-1.26l-2,.31-.63.95.47,1.57,1.57.78.32,1.26-.16.94h-2l-1.26.16h-1.57l-.63.94.16,2.2-.79.95h-1.57l-3.3-.32-1.41-.31-.63.47v1.41l1.1.79,1.73,1.26-2.52.47-.31,1.88v.63l.63,1.1.31,1.1-2.67.32.31,1.88,3,.47,1.41,1.89h-3.77v1.57a3.86,3.86,0,0,1-.63,1.73l-.15,1.26.94.31,1.73-.47.31,1.26-1.1.78-.31,1.42.31.94a9.73,9.73,0,0,1,1.73.78c.79.48-.63-.47.79.48l1.41.94s1.57-1.89,1.73-1.42a5,5,0,0,1,.16,1.26l-.95.47-1.1.79-.78.94-.16.63.16.63v.94l-.63.63-2.51.94v2.83l.62.63,2.05-.16,2.83-.47v4.09l-.32,1.25-3.3-.78-1.57-.79.16,2.52.94,1.57,1.73,1.26,1.88,1.57,1.26,1.25.47,1.89s-1.1.47,0,.63a13.56,13.56,0,0,0,2.52.31,11.17,11.17,0,0,1,2.35.32l1.89.15a4.72,4.72,0,0,0,2.2-.31c1.41-.47,2.83-1.1,2.83-1.1l2.67-2.67c2.08-4.84,4.35-6.5,6.13-7.07l4.24-1.1h0v-6.92l.79-.31s1.41.94,1.57,1.88.31,3,.31,3l.79,1.1c.33.21.7.43,1.1.64a14.71,14.71,0,0,0,1.73.77l1.25,1.1,2.05-2.67-1-2.35-.31-3.62s.94-2,1.1-2.51,1.26-1.1,1.26-1.1,2-6.29,1.73-6.76-1.58-2.83-1.58-2.83l-1.1-2.67h1.89l.94-4.09v-2.2l-4.08-2.67.94-2-2.51-13,.78-4.25.47-3.77,1.1-2,2.36-1.1h6.44a29.92,29.92,0,0,0,.16-4.24c-.16-.95-1.57-1.26-1.57-1.26l-1.42-2.67,3.46-7.23-2-8.48,3.14-1.26s1.26-.47,1.73-.63,0-1.26,0-1.26l-1.1-1.1.16-1.88,2.67-2.52a15.36,15.36,0,0,0,1.1-2.67,7,7,0,0,0-.16-1.73c-.16-.63-1.26-3.93-1.26-3.93l2.36-6.12,3-.95a17,17,0,0,0,2.51-.15c.47-.16,0-.95,0-.95v-3.14l.79-2.36c.31-.94,2.35,0,2.35,0l4.09.63.94-.63-.31-3.14-1.26-2.2-.63-2.51,3.77-.48,1.58,1.42-.32-2.36-1.1-.94.63-1.1,2.51-.63s1.73,2,2.2,2.67a29.77,29.77,0,0,1,1.58,3.14c.31.63,1.25,0,1.88,0a25.45,25.45,0,0,0,2.83-.47.81.81,0,0,0,.79-.94l.31-1.41,3.61,1.25,2.36,1.57,1.41-3,.16-4.72-1.26-1.88,1.42-3.3.31-3.46,3.3-1.88,2.36-2.05,2.36,2.36,3.3.94-.16,4.4Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2399.2,526.09l-.26.07Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2399.55,526l-.25.07Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2399.89,525.91l-.27.07Z"
        transform="translate(-2223.59 -372.99)"
      />
      <polygon
        className="cls-2"
        points="175.3 153.18 175.3 153.18 175.3 153.18 175.3 153.18"
      />
      <path
        className="cls-2"
        d="M2400.19,525.83l-.2,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2401.46,525.47h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2401.43,525.48l-.07,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2401.34,525.5l-.11,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2401.18,525.55l-.12,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2400.74,525.67l-.15.05Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2401,525.6l-.19,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2400.51,525.74l-.25.07Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2447.41,403.09a.74.74,0,0,1,.09.12A.74.74,0,0,0,2447.41,403.09Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2447.13,402.73l.13.17Z"
        transform="translate(-2223.59 -372.99)"
      />
      <polygon
        className="cls-1"
        points="231.03 31.75 230.99 31.95 231.03 31.75 231.03 31.75"
      />
      <path
        className="cls-1"
        d="M2447.29,402.94l.09.11Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2468.1,436.84h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2465,438.1l-.24.13Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2468.15,436.85a2.24,2.24,0,0,1,.59.2A2.24,2.24,0,0,0,2468.15,436.85Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2468.09,436.84h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2445.71,401l-.11-.13h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2447,402.55c.05.06.09.12.14.17S2447,402.61,2447,402.55Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2445.75,401.07l.09.11Z"
        transform="translate(-2223.59 -372.99)"
      />
      <a href="/sweden">
        <path
          className="cls-1 sweden active"
          d="M2456.46,439.83c0-.63-2.67-1.1.79-1.58s1.72-.94,3.45-.47a11,11,0,0,0,2.52.47,2.6,2.6,0,0,0,1.49,0l-3.22-4.53v-5.35a27.47,27.47,0,0,0-1.89-3.14,6.49,6.49,0,0,1-.94-1.73l-.47-3.93-1.1-.31L2456,412l-3.46-1.41-8.17-3.15-.78-1.88-1.58-1.42-3.77.48.63,2.51,1.26,2.2.31,3.14-.94.63-4.09-.63s-2-.94-2.35,0l-.79,2.36V418s.47.79,0,.95a17,17,0,0,1-2.51.15l-3,.95-2.36,6.12s1.1,3.3,1.26,3.93a7,7,0,0,1,.16,1.73,15.36,15.36,0,0,1-1.1,2.67l-2.67,2.52-.16,1.88,1.1,1.1s.47,1.1,0,1.26-1.73.63-1.73.63l-3.14,1.26,2,8.48-3.46,7.23,1.42,2.67s1.41.31,1.57,1.26a29.92,29.92,0,0,1-.16,4.24h-6.44l-2.36,1.1-1.1,2-.47,3.77-.78,4.25,2.51,13-.94,2,4.08,2.67v2.2l-.94,4.09h-1.89l1.1,2.67s1.26,2.36,1.58,2.83-1.73,6.76-1.73,6.76-1.1.63-1.26,1.1-1.1,2.51-1.1,2.51l.31,3.62,1,2.35-2.05,2.67-1.25-1.1-1.57-.47c.15.63.62,2.2.62,2.2l.79,6H2410l2.51-.31-1.41,7.07.47,1.26,2.2,1.1-.32,1.57V545l1.89,1.26s1.26,3.46,1.57,4.08,3,2.05,3,2.05v1.88a9.77,9.77,0,0,1-.95,2.67s-2.2,0-2.2.63a6,6,0,0,0,.48,1.73,9.54,9.54,0,0,1,2,1.42c.31.47,3.3,2.67,3.3,3.14s-2.52,2-1.26,2.51,7.07.79,7.07.79,2.2-.63,2.2-1.26.32-.63,0-1.57a17.92,17.92,0,0,0-1.1-2.36l.32-1.73,1.57-.94.94-1.57.32-1.1,1.88-.94H2439s1.41,2.83,1.41,1.57a41.07,41.07,0,0,1,1.73-7.23,32.36,32.36,0,0,0,1.42-6.76c-.16-.78-.79-3.61-.79-3.61s-.47-5.5-.47-6-.16-5.66-.16-5.66l-.16-1.73,3.62-2.35,1.41-1.73,1.26.47a8.91,8.91,0,0,0,1.1-.94l1.73-1.73.47-.79v-1.57l-2.36-.16a10.57,10.57,0,0,1-1.57,1.1,12.89,12.89,0,0,1-2.36.63,5.69,5.69,0,0,1-1.25.16l-1.26-1.42-1.1-.15-3.93-.47h-1.57s-.31-1.26.47-1.26h7.54s1.58-2.36,2.05-2.36a.71.71,0,0,1,.63.47l.47,2.2,5-3.3.62-1.57-1.41-3.14-2.51-.63-1.26-1.1-.94-1.1-3.46-1.57-2.36-.79-.63-1.25-.78-9.59V489.8l-.16-.95.94-1.25-.78-1.26s-.16,0-.79-.94-.94-.79-.94-1.42a18.15,18.15,0,0,1,.47-2.51h1.73l1.73-.16.31-6.13,2.36-.78.47-.95.47-2.51,3.14-.47s1.89-6.76,2.67-7.23,3.3-1.26,3.78-2.67.78-2.67.78-2.67l.32-3.93s-2.83-1.26-2.83-1.73.31-2.2.31-2.2l.79-2.83.15-2,1.73-1.57s1.57-.16,1.42-.79S2456.46,440.45,2456.46,439.83Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-1"
        d="M2446.05,401.43l.17.2Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2445.91,401.26l.11.13Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2446.6,402.09c.06.07.11.14.17.2S2446.66,402.16,2446.6,402.09Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2446.81,402.35l.12.14Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2446.43,401.89l.15.18Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2446.25,401.67l.14.16Z"
        transform="translate(-2223.59 -372.99)"
      />
      <polygon
        className="cls-2"
        points="350.09 198.01 347.9 197.42 350.09 198.01 350.09 198.01"
      />
      <path
        className="cls-2"
        d="M2501.4,593.14l.95,4.93,1.41.78,2.2-.16,1.1-2.2,6-2.51,1.57-1.1,1.42-.47,3,.16h1.42l3-.63,4.09.63,3.14,2,1.42.63.78-1.57v-.79a16,16,0,0,1,3.62-.79,14.7,14.7,0,0,1,2.2.16s2.2,0,2.67-.47v-1.1l1.1-.31.78.15.79,1.89,3-.32a9.48,9.48,0,0,1,2.2-1.1c.47,0,4.56.79,4.56.79l1.89-.47-1.89-4.09-.68-6.86,4.92-2.72-3.77-6.6-.63-5.35,2.52-.94,2.83-1.26v-3.14c0-1.26-3.15-1.57-3.15-1.57l-1.88,1.26-1.57-.32-1.58-1.88-1.57-2.2-2.83-.95-1.57-3.77-4.08-1.57-.32-2.51-1.25-2.2,1.57-3.14-1.89-1-4.4-.63-3.14,2.52-2.51-2.52c-.95-.94-1.58,0-1.58,0l-.94,1.89-1.57-.94-1.26-.32-2.2,1-1.13-.46-1.8,1.4-.42,2.09v1l-2.2-.53-1.36,1.36-2.83,3,.31,2.41.84.53.95.41v1.16l-4.3,5.55.1,6s1.79.11,1.79.42a21.55,21.55,0,0,1-1.47,2.72s-1-1-1.47-1.36a6.89,6.89,0,0,0-1.25-.63l-3.46,6.08-1.89-.11-1.88-.1-1.26.52-2,.21-.63,1,2.31,4.3,2.82,2.93,1.58,5.34s-3.36,2.52-3.36,2.83-.31,2.2-.31,2.2.52,1.05.84,1.15A13.14,13.14,0,0,0,2501.4,593.14Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2505.49,514.78l1.26-6.91,2.51-2.83v-1l-.47-.67L2506,503l-1.73,1.25-4.24-.15-3.77-.16s-3.93-.32-3.93.16.78,1.25-.16,1.72-2.2,1.1-3,1.42-2.2.78-2.2.78a4.33,4.33,0,0,1-.48,2.05,7.68,7.68,0,0,1-2.2,1.73,3.18,3.18,0,0,0-1.41.94c-.31.47-2,2.2-2,2.2l1.73,3.14,1.57,2.83,1.73,2h2.51l1.41-.94.63,1.1.32,4.87v1.15l2.83-3,2.35-1.26h5.35l1.41,2.2,1.57.16,6.6-1.42.63-4.08Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2499,541.7l2.83,3.15,2.2.1,1.26-.84,1.47,1.16,2.3,2,2.41,2.09,2.83-3,1.36-1.36,2.2.53v-1l.42-2.09,1.8-1.4-2-.8-.94-3.46c-.95-3.46,0-3.46,0-3.46l-2.2-.31-1.89-.63v-4.71l-2.2-1.89-6.6,1.42-1.57-.16-1.41-2.2h-5.35l-2.35,1.26-2.83,3V530l.63,1,.94,2s-.79,3.3-.79,3.77,0,1.57-.78,1.57-3.46.16-3.46.16a4.63,4.63,0,0,1-.94-.47c-.47-.32-.47-.32-.63-.94s-.16-2.52-.63-2.68a14.26,14.26,0,0,0-1.41-.31h-1.73l-1.57-2-1.73-.79-3.15,2.2-1.1,2.52-1.57,8,.16,5,1.73,3.77.16.31,3.82-5.34,12-2.72s.94,1.57,1.25,1.57,4-1.47,4-1.47Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2498.47,572.92l1.26-.52,1.88.1,1.89.11,3.46-6.08a6.89,6.89,0,0,1,1.25.63c.42.32,1.47,1.36,1.47,1.36a21.55,21.55,0,0,0,1.47-2.72c0-.31-1.79-.42-1.79-.42l-.1-6,4.3-5.55V552.7l-.95-.41-.84-.53-.31-2.41-2.41-2.09-2.3-2-1.47-1.16L2504,545l-2.2-.1L2499,541.7l-3,3.46s-3.67,1.47-4,1.47-1.25-1.57-1.25-1.57l-12,2.72-3.82,5.34h0a20,20,0,0,1,1.41,3.16c0,.47.16,3.3.16,3.3l1.1,1.25V561h.73s4.19,1.47,4.51,1.57,4.4.11,4.4.11,1-.42,1.46-.11a4.92,4.92,0,0,1,.84,1.68s-.31.94-.42,1.26a16.71,16.71,0,0,0-.21,1.78l1.47,1.15a5.61,5.61,0,0,0,1.78,1.26c.63.1,3.56,1.15,3.56,1.15a12.08,12.08,0,0,0,1,2.29Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2476.4,559.32l0,.21Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2476.39,559.13v0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2476.39,559v0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2492.08,569.68a5.61,5.61,0,0,1-1.78-1.26l-1.47-1.15a16.71,16.71,0,0,1,.21-1.78c.11-.32.42-1.26.42-1.26a4.92,4.92,0,0,0-.84-1.68c-.42-.31-1.46.11-1.46.11s-4.09,0-4.4-.11-4.51-1.57-4.51-1.57h-.73l.15,4.09h-1.1a34,34,0,0,1-5.5-.32l-.47.94-1.1.79.47,2.36,1.26.94a15.72,15.72,0,0,1-1.69,3l1.48.74,13.62-1.15,4.82-1.26a15.37,15.37,0,0,0,3.15-1.33A3.24,3.24,0,0,0,2492.08,569.68Z"
        transform="translate(-2223.59 -372.99)"
      />
      <a href="/uk">
        <polygon
          className="cls-1 uk active"
          points="67.4 193.65 66.3 190.66 65.52 188.93 63 188.78 60.22 189.42 59.6 190.19 55.41 191.87 54.36 194.38 53.31 196.27 54.57 199.62 55.62 199.83 57.92 199.62 61.9 201.92 63.23 202.87 63.32 202.29 64.89 202.29 66.15 201.19 67.72 200.25 69.29 199.62 69.92 197.42 67.4 195.53 67.4 193.65"
        />
      </a>
      <path
        className="cls-2"
        d="M2504.7,602.15l-.94-3.3-1.41-.78-.95-4.93a13.14,13.14,0,0,1-1.67-.21c-.32-.1-.84-1.15-.84-1.15s.31-1.89.31-2.2,3.36-2.83,3.36-2.83l-1.58-5.34-2.82-2.93-2.31-4.3.63-1h.15a12.08,12.08,0,0,1-1-2.29s-2.93-1.05-3.56-1.15a5.61,5.61,0,0,1-1.78-1.26l-1.47-1.15a16.71,16.71,0,0,1,.21-1.78l.42-1.26a4.92,4.92,0,0,0-.84-1.68c-.42-.31-1.46.11-1.46.11s-4.09,0-4.4-.11-4.51-1.57-4.51-1.57h-.73l.15,4.09h-1.1a34,34,0,0,1-5.5-.32l-.47.94-1.1.79.47,2.36,1.26.94a21.41,21.41,0,0,1-2.2,3.77c-.91,1.4-1.5,1.64-1.88,1.57s-.45-.25-1.07-.44a3.13,3.13,0,0,0-1-.19,23.46,23.46,0,0,1-3.77-.15,9.74,9.74,0,0,1-1.73-.79l.16-1.41.94-1.26.16-.63-.63-.16-3.93-.31-3.92.94-4.88,3.62s-8,7.38-9.42,7.38-3.3,1.73-3.3,1.73l-.32,2.52s-.16,1.41-1.1,1.1l-1.33-.47.19,2.1,1.7,2.69-.14,1.84-1.84,2v1.41l2.41,1.56,2,1.13.71,4.25s.42,2.27.56,2.69a29.56,29.56,0,0,1,.29,3.12l2,2.12.85,1-1,6.24,1.27.14.15-1,1.69-.15,1,2.27,8.07.57v.7s-1.7.71-1.13,1.28,2.83,2.41,2.83,2.41.71,1.41,1.27,1.27,2,.29,2-.71a3.63,3.63,0,0,0-.29-1.55l-1.41-1.7,1.7-.15,1.69.43,1.28,1.56,1.13-.43,1.56.43.28,1.27s-1.13,1,.85,1.14.43.56,2,.14l1.55-.43,1.85.29,1.41.14.43,2.12,2.55,2.83,2,.15,1.41-2.55,3,1.7.57,2.12h1.69l2.7-2.83,8.49-1,3.4-.85,3.16,3.15,1.9-.29,2.35-.63-.78-1.57-1.57-2.35V624l1.25-4.4,2.83-4.4,2.52-1.57a4.78,4.78,0,0,0,.78-1.57c0-.47-1.41-6.13-1.41-6.13Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2557,662.65l2.79,1.34,2.8-2.92,4.87-2.43-1.14-1.49v-2.83l.63-.47,1.41-.31,2.2-3.15s.63-.31,0-.94l-1.1-1.1-2.2-1.26-3.45,2.07-3.41-.25-.85,1v3.65l-.61,3.41-.73,3.4Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2573.37,643.38l.06,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2573.49,643.34l.06,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2564.57,643.79l-3.61-5.18-2-.63-.79-.79-1.1-3.77-1.57-2-2.36-.79-3.61.63-1.73-.47-7.07-.78-5.66,2.51-.1.23,3.34.09,8.56,10.63a7.69,7.69,0,0,0,1.91.84c.46,0,2.52.07,2.52.07l2.83,15.44.76,2,2.13.88,1.21-2.31.73-3.4.61-3.41v-3.65l.85-1,3.41.25,3.45-2.07v-1.57h.12l-.74-.63Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2572.8,643.57l.08,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2573.23,643.42h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2573,643.5l.07,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2568.66,658.43h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2567.44,658.64l-4.87,2.43-2.8,2.92-2.79-1.34-2.13-.88-.76-2-2.83-15.44s-2.06-.07-2.52-.07a7.69,7.69,0,0,1-1.91-.84l-8.56-10.63-3.34-.09.1-.22-1.88,4.39c-.21.49-.38.88-.5,1.19l-2,.38H2528l-1.41.79a25.32,25.32,0,0,0-2.2,2.2,9.61,9.61,0,0,1-1.26,1.25c-.47.47-1.73-.31-1.73-.31l-1.89-1.26-4.08.63s-2.83.16-4.24.32-3.62,0-4.88,0h-2.2L2506,646l-5.34,3.15.47,1.41-.47,2.83-4.09,13-3.14.79-.94.78a8.88,8.88,0,0,1-.79.63,3.43,3.43,0,0,0-.94,1.1l3,2.52,2.05.62.94,3,3,1.26,2.36,2.51s0,3,.63,3.3,4.24,1.89,4.24,1.89h1.57l2.2-2,1.73-.15.47.78-.62.79-.63.94,1.41,2,3.14.79v1.41a26,26,0,0,0,5.66,1.26c1.89,0,8.17-.94,8.17-.94a12,12,0,0,1,5.19-.94,45.32,45.32,0,0,1,4.71.47l1.26-.79,2.2-3.77a7.76,7.76,0,0,1,3.61-3.46c2.52-1.1,4.56-2.35,5.82-2.35s4.71,1.25,6,1.72a37,37,0,0,0,6,.76,2.92,2.92,0,0,0-.33-.91c-.48-.79-.32-.79-.63-2s-.79-5-.79-5V670l-.16-3.46.48-1.42c.78-.15,1.72-.15,1.72.32v1.41l.63.47,3.3-1.57v-3.61c0-.81.4-1.37.16-2A2.88,2.88,0,0,0,2567.44,658.64Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2535,632.48Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.62,677.54l0,.12Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.65,677.73l0,.11Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.58,677.33l0,.14Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.54,677.1l0,.16Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.5,676.84l0,.21Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.76,678.23l0,.13Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.22,674.94h0l.09.68Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.69,677.91l0,.11Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.72,678.08a.36.36,0,0,1,0,.1A.36.36,0,0,0,2563.72,678.08Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.32,675.67a1.11,1.11,0,0,1,0,.17A1.11,1.11,0,0,0,2563.32,675.67Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2564.62,680.86a2.64,2.64,0,0,1,.13.46A2.64,2.64,0,0,0,2564.62,680.86Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.46,676.61l0,.17Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2564.42,680.41c0,.06.07.12.1.19S2564.45,680.47,2564.42,680.41Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2562.69,686.06l1.25-.31.95-3.3a5.5,5.5,0,0,0-.14-1.13,37,37,0,0,1-6-.76c-1.26-.47-4.72-1.72-6-1.72s-3.3,1.25-5.82,2.35a7.76,7.76,0,0,0-3.61,3.46l-2.2,3.77-1.26.79a45.32,45.32,0,0,0-4.71-.47,12,12,0,0,0-5.19.94s-6.28.94-8.17.94a26,26,0,0,1-5.66-1.26V688l-3.14-.79-.12-.18-.45,4.09-.51,1.55.9,1.54a7,7,0,0,1,.9,1.54c.13.52,2.44,2.32,2.44,2.32l3.09,1.15-3.73,5.79-.64,3.21s.12,2.7.64,3.08a32.28,32.28,0,0,0,3.6,1.55l1.93,1.15,1.54,6.81,7.71-1.67,2.44-3.34h3l1.41,1.54h3.6l3,.26a14.11,14.11,0,0,0,3.59-1c.65-.51,3.22-1.41,3.22-2.18v-3.22l2.18-2.57s.39-3.08,1.29-3.34,4.37-1.54,4.37-1.54l1.28.51h1.8l2.86-1.8a12.74,12.74,0,0,0-1.6-2.33c-.47-.31-1.57-1.57-2.2-1.73a5,5,0,0,0-1.1-.16s.94-2.2,1.25-2.82-.15-4.72-.15-4.72V688Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2564.54,680.65a1.34,1.34,0,0,1,.07.18A1.34,1.34,0,0,0,2564.54,680.65Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.36,675.92l0,.15Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.43,676.39l0,.15Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.39,676.16l0,.14Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2564,701.87l-.06-.08Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2564.06,702l.13.21Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2564.2,702.24l.09.14Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2559.52,697.86l-.13.3.13-.3Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.8,701.57l0,.06Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2562.78,700.12l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.33,700.84h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2562.89,700.24l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2575.26,707.75l-4.87-.16s-2.2-1.73-2.83-2.2-3-2.51-3-2.51l-.28-.5-2.86,1.8h-1.8l-1.28-.51s-3.47,1.29-4.37,1.54-1.29,3.34-1.29,3.34l-.72.85,1.5,1,.1,1.67-1.78,2.1.32,2.41s-.68,2.14-1.25,4c.09.14.54.91.83.91a16.09,16.09,0,0,0,1.57.42,13.74,13.74,0,0,0,1.88-.31l2.1-.53.94-.21s1.26.84-.31,1.16-1.57,0-1.89.52-.42.73-.63,1.05-2.09,3.25-2.09,3.25l1.15,1.36s2.52-4.72,2.93-4.82a30.52,30.52,0,0,0,3-2.1l1.36-1.88.84-3.14.32-.74,5.92-2.72a13.46,13.46,0,0,1,2.35-.79,22.8,22.8,0,0,0,3.3.16,1.55,1.55,0,0,0,1.1-1.41C2575.57,710,2575.26,707.75,2575.26,707.75Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563,700.42l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.63,701.3l0,.05Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.16,700.6l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2563.48,701.06l0,.06Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2550.94,720.68h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2551,720.75h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2550.9,720.62v0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2551.23,721.1l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2550.88,720.58v0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2551.15,721h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2551.57,721.44l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2551.3,721.19l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2551.82,721.49h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2551.63,721.46h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2551.37,721.27l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2551.5,721.39l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2551.41,721.31l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2553.47,710.37l-1.5-1-1.46,1.72v3.22c0,.77-2.57,1.67-3.22,2.18a14.11,14.11,0,0,1-3.59,1l-3-.26h-3.6l-1.41-1.54h-3l-2.44,3.34-7.71,1.67-1.94,1.34-.42,1.26-2.51,1.36-2.73-.21-2.09,2s-.53,2.1-.95,2.2-2.72.21-2.72.21l-2.72,1.05.1,3.25-.84,4.08-.42,1.78-1.67.84-2.46,5.54a2.54,2.54,0,0,0,.26.33c.31.31,4,3.66,4,3.66l3.67,1,1.25-.31s1.57.94,1.57,1.25.32.63-.1.63h-3.25l-.63.42s-1,.74.11,1.15l1.15.42s1.57,1.05,1.68,1.47,1,2.41,1,2.41l.95.31s1.15-1,1.88-1,2.31.1,2.73.1,2.41.32,2.61,0a7.67,7.67,0,0,0,.42-.73l1.16-.32,1.25.21,1.05-.31.42-.63,2.1-.1,2.61.73,1.05.1.74,1-.42.42-1,.31.32.84.1.52-.84.74-.83.2-3.46-.62-2.41-1.05a3.15,3.15,0,0,0-.94-.32c-.32,0-1.68-.1-1.68-.1s-.21-.52-.73,0-.53.94-1.26,1.36-.84.63-1.26.63-2.3-.31-2.3,0-.32,3-.32,3l-.73.1-.84.63,5,1.78.52,2.62,1.26,2.1-.31,2s-1,0,.21,1a18,18,0,0,0,2.83,2s.21.42.52,0a1.52,1.52,0,0,0,.42-1.25V772l2,.21s-.11,1.25.31,1.46,1.57.84,1.57.84-.31,3.14.11,3.35,1.78,1.68,1.78.84v-3.56l.73-1.47,1.05.11.63.94s.31,1.26,1.15,1.47,2.62,1.15,2.2.63a1.36,1.36,0,0,1-.31-1l-.32-3a22.34,22.34,0,0,0-1.88-3,30.63,30.63,0,0,1-3-3.77c-.1-.31.63-1.78.63-1.78l1.88.84s.95-.21,1,.52a8.73,8.73,0,0,1,.11,1.15l1.78-.41,2.62-1.47-1.78-1.36-.84.31s.42.42-.11.42a4.37,4.37,0,0,1-1.15-.21s-.21,0-.21-.42a5.5,5.5,0,0,0-.52-1.46v-.84l-1.26-.21v-1.36l2.1-1.05,1.15-.73,2,.83s-.11.84.94,1.05,2,.32,2.31.42a5.31,5.31,0,0,1,.83.42l-.94-2-1-2,.42-1.47-1.57-.94-1.47-.84h0l2.58-.62,1.57,3.46,3,.47,1.41-.31-.31-1.1-3-.79-1.41-4.71-1.42-1s-4.4-.31-5-.47,0-1.1,0-1.1l-3.3-.31-1.89,2.35s1.57.16,2,.16,4.25,2,4.87,2.2c.34.09.36.62.31,1.1h-2.66l-1.05-1.15-.63-.42-.52.63h-.84a7.16,7.16,0,0,1-.53-1s-.1-.21-.52-.21-2.83.21-2.83.21l-1.46-.31s-.32-.53,0-.63a23,23,0,0,0,2.09-1.57l.84-.74a8.87,8.87,0,0,0-.42-1.88c-.21-.32-.94-.74-.21-1.36a6.46,6.46,0,0,1,1.15-.84,1.24,1.24,0,0,1,.95.21,2.53,2.53,0,0,1,.41,1.15l-.1.84a.75.75,0,0,0,.52,0,6.27,6.27,0,0,0,1.16-.94l-.74-1.89s-1.36-.63-2-.84a31.61,31.61,0,0,1-3.66-2.93l-2.62-2.94.31-5.76s.94-1.67,1.36-1.67h.42l.53.94s-1.16.94-.84,1.26a1.24,1.24,0,0,0,.94.52,22.19,22.19,0,0,1,2.83.94s1.88,2.83,2.3,2.94,2.1.21,2.1.21l.94.1-.52-.63-1.68-.84-.63-.21-1-1.15.21-.94.73-.31,1.67.31,1.16.84,1.36,1.46.63-.41s.63,0,.21-.74a3.63,3.63,0,0,0-1.26-1.46c-.42-.21-1.36-.84-1.36-.84s-.21-.74.42-.74a5.34,5.34,0,0,1,1.88.11c.42.21,1.47.84,2.1,1.26s.94.83,1.15.52a3.71,3.71,0,0,0,.31-1.15,1,1,0,0,0-.52-.53,2.41,2.41,0,0,1-.73-.62l-2.2-.74-1.78-.42-1.37-.94-.62-1.36-.21-.74,3,.21,1.89-2.3,2.1-1.26s.52.74.83.74a10,10,0,0,0,1.26-.21s2.1-2,2.62-2l8.8.1v0c.57-1.87,1.25-4,1.25-4l-.32-2.41,1.78-2.1Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2519.15,712.8a32.28,32.28,0,0,1-3.6-1.55,1.41,1.41,0,0,1-.34-.72l-1.13.68h-1.78l-1.36-.63-1.58.63-.83,2.09-3.36,1.47-.62,2-.63,1.68-3.25.52-.21,1.88.63,2.1.52,2.72a7.09,7.09,0,0,0,.63,2c.21.21,2.63,1.48,4.3,2.34v0l2.72-1.05s2.3-.1,2.72-.21.95-2.2.95-2.2l2.09-2,2.73.21,2.51-1.36.42-1.26,1.94-1.34-1.54-6.81Z"
        transform="translate(-2223.59 -372.99)"
      />
      <polygon
        className="cls-2"
        points="299.03 347.77 302.28 347.07 302.28 347.07 299.03 347.77"
      />
      <path
        className="cls-2"
        d="M2502.78,747l.08.07Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2502.59,746.79l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2502.34,746.55l.11.11Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2503,747.15l.06.06Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2501.25,745.45l2.46-5.54,1.67-.84.42-1.78.84-4.08-.1-3.22c-1.67-.86-4.09-2.13-4.3-2.34a7.09,7.09,0,0,1-.63-2l-.52-2.72-.63-2.1.21-1.88,0-2-.71-1.8-3.07-1.89-1.41-2-2.44.86-1.1-.31-.55-1-.62,2.52-1.18,1.57.08,1.57-.22,3c.65.28,1.45.65,1.45.65.52.21,1.46,2,1.46,2a4.13,4.13,0,0,0-.42,1.36V725l.32.83.42.42.42,1.47-.74,1.78v.84l.32,1V732l-1.15,2.2s.31,1.05.62,1.15a4,4,0,0,1,.84.53s1.15.62.42.94-.31-.11-.73.31-.74-.1-.42.42a5.28,5.28,0,0,0,1.15,1.15l1.15.11,2.52.73.73.84,1.89,3.14.31.95h.63a9.36,9.36,0,0,0,.72,1.21S2501.3,745.51,2501.25,745.45Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2503.18,747.33l.14.13Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2501.51,745.78l-.12-.14Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2503.69,747.8l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2502.18,746.41l.05,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2502,746.26l.05,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2501.56,745.82v0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2504,748.09l-.17-.15Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2504.35,748.4l0,0h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2501.88,746.13l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2501.63,745.9l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2501.74,746h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2526.14,690.21l-.31,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2525.43,690.3l-.27,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2525.77,690.26l-.27,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2524.06,690.46l-.2,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2525.08,690.34l-.25,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2524.4,690.42l-.22,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2526.48,690.17l-.32,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2524.74,690.38l-.24,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2523,690.56h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2522.23,690.61h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2522,690.62h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2523.56,690.51l.18,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2523.26,690.54l.16,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2522.46,690.6h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2522.71,690.58h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2499.83,701.62l3.85,4.32,4.79,2.12.24,1-1.41,3.22-.11,1.57,1.34-.58.83-2.09,1.58-.63,1.36.63h1.78l1.13-.68a14.23,14.23,0,0,1-.3-2.36l.64-3.21,3.73-5.79-3.09-1.15s-2.31-1.8-2.44-2.32a7,7,0,0,0-.9-1.54l-.9-1.54.51-1.55.45-4.09.12.18-1.41-2,.63-.94.62-.79-.47-.78-1.73.15-2.2,2h-1.57s-3.61-1.57-4.24-1.89-.63-3.3-.63-3.3l-2.36-2.51-3-1.26-.94-3-2.05-.62-3-2.52-6.45-.71-.86,1.34-2.2.71-2,2.75s1.1,4.16,1.25,4.63.95.71.95.71a20.26,20.26,0,0,1,2.27,1.18c.24.23,0,.31,0,.55s-.86.39-1.17.63.31,2,.31,2a13.29,13.29,0,0,1,1.34,1.81,6.39,6.39,0,0,1,0,1.18l-.71,1-.79,2.36,1.26.47,2.28,2.12.16,1.73-.32.63-.39.07-.94-.31-1,.08.55,1.81.55,1.8-.86.55v.87l8.49,6.44,4.71.71,1.65-2.2-.94-1,.78-1Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2515.43,711.11a.08.08,0,0,1,0,0A.08.08,0,0,0,2515.43,711.11Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2515.28,710.76h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2515.35,711v0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <polygon
        className="cls-2"
        points="276.87 347.85 276.96 348.14 276.96 348.14 276.87 347.85"
      />
      <polygon
        className="cls-2"
        points="283.71 339.32 285.12 336.1 284.89 335.07 280.09 332.95 276.24 328.63 275.06 329.65 274.28 330.6 275.22 331.62 273.57 333.82 273.18 334.92 272.55 335.78 271.29 336.25 270.74 336.49 271.01 338.54 271.92 338.22 273.34 340.26 276.4 342.14 277.11 343.95 277.08 345.97 280.33 345.44 280.96 343.77 281.59 341.78 284.94 340.31 283.61 340.89 283.71 339.32"
      />
      <path
        className="cls-2"
        d="M2495.51,711.21l-.91.32-.27-2,.55-.24,1.26-.47.63-.86.39-1.1-4.71-.71-7.86-6-1.49-.24-2.28-.63-.79,1.18.79,2.6,1.73,2.12.07,1.25-1,.55-.08,1.89.55,1.1-2.12,2.36.24,1.74,2.46.3,1.15.84,2.52,2.72a25.06,25.06,0,0,0,2.41,1.26c.42.1,2.2.94,2.2.94a5.05,5.05,0,0,1,1.24,1.58l4.91-3.88,2-3.22-2.19-1.34Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2483.1,699.89l1.49.24-.63-.47v-.87l.86-.55-.55-1.8-.55-1.81,1-.08.94.31.39-.07.32-.63-.16-1.73-2.28-2.12-1.26-.47.79-2.36.71-1a6.39,6.39,0,0,0,0-1.18,9.08,9.08,0,0,0-1.08-1.5l-3.09,1.87-1.05-1.89-6.81-.52-.83,1.15-4.3-.63-3.25-.52H2462l-.94.94-1.57.21-1.47,1.36-1.15-.94-1.26-.42-.84,4.4,1.79,1.78,2.61,4.61,8.07,7.65H2469l2,1.57,2.62,2-.1,1.57s-.21.84.94,1.15,2.09.11,3,.73a16.57,16.57,0,0,1,2.43,2.47l2.12-2.36-.55-1.1.08-1.89,1-.55-.07-1.25-1.73-2.12-.79-2.6.79-1.18Z"
        transform="translate(-2223.59 -372.99)"
      />
      <polygon
        className="cls-2"
        points="262.32 328.15 265.4 330.49 265.4 330.49 262.32 328.15"
      />
      <path
        className="cls-2"
        d="M2484.23,685.54v0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2484.2,685.28s0,.06,0,.09S2484.2,685.31,2484.2,685.28Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2484.2,685.28a.93.93,0,0,0,0-.1A.93.93,0,0,1,2484.2,685.28Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2484.23,685.84v0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2484.2,686.35h0c0-.05,0-.13,0-.21C2484.21,686.22,2484.21,686.3,2484.2,686.35Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2484.23,686a.57.57,0,0,0,0,.13A.57.57,0,0,1,2484.23,686Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2484.23,685.68v0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2484.22,685.4a.45.45,0,0,0,0,.11A.45.45,0,0,1,2484.22,685.4Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2477.52,709.84c-.95-.62-1.89-.41-3-.73s-.94-1.15-.94-1.15l.1-1.57-2.62-2-2-1.57h-1.78l-8.07-7.65-2.61-4.61-1.79-1.78.84-4.4,1.26.42,1.15.94,1.47-1.36,1.57-.21.94-.94h1.78l3.25.52,4.3.63.83-1.15,6.81.52,1.05,1.89,3.09-1.87-.26-.31s-.63-1.73-.31-2,1.17-.4,1.17-.63.24-.32,0-.55a20.26,20.26,0,0,0-2.27-1.18s-.79-.24-.95-.71-1.25-4.63-1.25-4.63l-2.15.1-1.57,1.78-6.5-.84-.84-1-3.66.21-6.29-4.93h-1.15l-.94,1.68-2.62.94-.42,4.82-2.1.84-.31,3.14-.84.94h-3.46l-1.67-.41-.32-.95-1.67.74-1.36,1.15-6.61,1c-.23.31-.55.82-.41,1.09s.83,1.89.83,1.89,1.58,2.62,1.79,2.93.2,1.16.62,1.16h.42s1.36.2,1.57-.21a2.6,2.6,0,0,0,.42-1.16,16.76,16.76,0,0,1,.32-1.88v-2.62s-.32-1.26,1.05-.53,3.66,2.41,3.66,2.41l2.2,1.47a4.74,4.74,0,0,0-.42,2.52c.32.83,2.1,2.61,2.2,2.93s1.05,2,1.05,2h1l.63.94-.84,1.15-.32,1.79,1.26.83s1.78,1,2.2,1.16l2.62,1.25.31,1.15.63.74,1.16.1,1.88-.42a14.36,14.36,0,0,1,3,0l.63.21s4.08,2.83,4.71,3a19,19,0,0,1,2.31,1.26l1.46,1.26.32.83,1.46.42,1.68.63,2.31,1.89,1.46.84h.16l-.24-1.74A16.57,16.57,0,0,0,2477.52,709.84Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2484.14,685.15l-.07-.12Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2483.12,683.78l.3.37Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2483.9,684.79l-.1-.14Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2483.76,684.59l-.15-.19Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2484.05,685l-.11-.16Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2483.58,684.37l-.13-.17Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2434.67,675.8l-.21,1.25,1.4,2.62h.28l.42,1.26s.31.11,0,.52a10.21,10.21,0,0,1-1.58,1.26l-.21.27,6.61-1,1.36-1.15,1.67-.74.32.95,1.67.41h3.46l.84-.94.31-3.14,2.1-.84.42-4.82,2.62-.94.94-1.68h1.15v-.83l-2.51-2.94h-2.1v1.26l.32.52-1.37.42h-1.36l-1.25,1.26-4.51-.11-3,3-4.08-.31-3-.21-2.41,3.35,1.57.63Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2506.52,642.07h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <polygon
        className="cls-2"
        points="233.28 296.49 233.28 296.49 233.5 296.1 233.28 296.49"
      />
      <a href="/hungary">
        <path
          className="cls-2 hungary active"
          d="M2506,646l-1.89-3.93-3.77-2.35-3.4,1.31-1.68-2.2-3.14,1.46h-4l-1.26-.31s-2.93,6-3.35,5.76a3.69,3.69,0,0,0-1.26-.21l-1.36-.94-.52.31-.74,3-4.29.42-1.68,2.72-4.71,1.26-2.41.63-3.35-2.62-2.94-.1.63,4.29h-3.25l-.73,1.05,1.36.73-.94,1.26-.84,1.26,1.15,2.83v1.15l-2.09.84-.45,1.67h.66l2.51,2.94v.83l6.29,4.93,3.66-.21.84,1,6.5.84,1.57-1.78,2.15-.1,2-2.75,2.2-.71.86-1.34,6.45.71a3.43,3.43,0,0,1,.94-1.1,8.88,8.88,0,0,0,.79-.63l.94-.78,3.14-.79,4.09-13,.47-2.83-.47-1.41Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-2"
        d="M2463.17,650.34l3.35,2.62,2.41-.63,4.71-1.26,1.68-2.72,4.29-.42.74-3,.52-.31,1.36.94a3.69,3.69,0,0,1,1.26.21c.42.21,3.35-5.76,3.35-5.76l1.26.31h4l3.14-1.46,1.68,2.2,3.4-1.31-.63-8.17,2-.31-1.82.28-3.16-3.15-3.4.85-8.49,1-2.7,2.83h-1.69l-.57-2.12-3-1.7-1.41,2.55-2-.15-1.72-1.91,0,0-2,2.33L2467,634l-1.1,4.9-5.69,2.34-1.32,1.46-.07,4.23,1.76,3.37Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2458.91,642.65l1.32-1.46,5.69-2.34,1.1-4.9,2.63-1.9,2-2.33,0,0-.83-.92-.43-2.12-1.41-.14-1.85-.29-1.55.43c-1.56.42,0,0-2-.14s-.85-1.14-.85-1.14l-.28-1.27-1.56-.43-1.13.43-1.28-1.56-1.69-.43-1.7.15,1.41,1.7a3.63,3.63,0,0,1,.29,1.55c0,1-1.42.57-2,.71s-1.27-1.27-1.27-1.27-2.27-1.84-2.83-2.41,1.13-1.28,1.13-1.28v-.7l-8.07-.57-1-2.27-1.7.15-.14,1-1.27-.14-.55.64-1.44.36-.18-1V618l-2.7.45.09.72a.55.55,0,0,1-.09.63,14.88,14.88,0,0,1-2,1.44s-1.35,0-1.35.26a4,4,0,0,1-.54,1.08l-1.26.9h-1.26a6.76,6.76,0,0,0-.63.72,5.53,5.53,0,0,1-1.17.81l-1.44.36s.18,1.08-.18,1.08h-2.79a6.62,6.62,0,0,0-.81,1.08c-.09.27-.54,1.26-.54,1.26l-1-.63-.72-.36-.36,1.26,1.53,1.71,1,1,.81,1.71-.27,1.17,1.62,3.41,2.25.63,2.07.81,1.17,2.25,2.7,1.08,2.78,1.71s1.8,2.16,2.16,2.16h5.22l1.62-3.87.63-1.26,5.66.27,2.07,1.26s1.17-.18,2.07-.36a11.38,11.38,0,0,1,1.89-.27c.29,0,2,.4,3.08.65Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2460.86,654.53l-.63-4.29h.37l-1.76-3.37.06-3.75c-1.09-.25-2.79-.65-3.08-.65a11.38,11.38,0,0,0-1.89.27c-.9.18-2.07.36-2.07.36l-2.07-1.26-5.66-.27-.63,1.26-1.62,3.87h-5.22c-.36,0-2.16-2.16-2.16-2.16l-.61-.38-.69,3.71-1.41-.47-.63-.32-1.26.47.16,2.52-3,1.1-.79,1.88,2.67,2.68,1.42,2-1.73,1.41-2.52-1.57h-3.45l-1.1,1.73-3.78,1.73-5.81,1.26-.63-1.58-4.87-.15-.31,2a15.49,15.49,0,0,1-2.2-1.41,11.6,11.6,0,0,1-1.1-1.42l-2.68.47.32,2.05.31,2.51a1.73,1.73,0,0,0-.15,1.1,10.45,10.45,0,0,0,1.72,1.89l2.83.78,2.2-.94,1,1.26,3,.78,1.73-1.1s1.1-1.88,1.57-1.88h3.14l4.09-1.89v1.57l1.57,2,2.67,1.89,9.17.84,3,.21,4.08.31,3-3,4.51.11,1.25-1.26h1.36l1.37-.42-.32-.52v-1.26h1.44l.45-1.67,2.09-.84v-1.15l-1.15-2.83.84-1.26.94-1.26-1.36-.73.73-1.05Z"
        transform="translate(-2223.59 -372.99)"
      />
      <polygon
        className="cls-1"
        points="213.45 298.32 211.71 298.2 213.45 298.32 213.45 298.32"
      />
      <a href="/italy">
        <path
          className="cls-1 italy active"
          d="M2484,739.6l-1.15-1.05-4.4-2.72a28,28,0,0,0-2.93-1.89c-.42-.11-6.5-1.89-6.5-1.89l-6.18-2.3-2.51-1.47-1-1.15,1.37-1.36s.62-.53.62-.94a9.72,9.72,0,0,0-.41-1.68l-3.67-.42h-3.25l-1.26.21a5.85,5.85,0,0,1-1,.21,32.17,32.17,0,0,1-3.15-1.26l-5.76-4.4-4-8.9-2.83-3.77-11-6.29s-.63-4.71-.52-5.24-.11-2.2.42-2.2h.94l.11-1-.11-1-2.09-3.46,1-1.57.84-.52.21,1.15h.73s0-.32,1-1l2.41-1.57,1.36-1.36v-.63h1.46l1.16.21.42-.63h1.5l-1.4-2.62.21-1.25-.21-.63-1.57-.63,2.41-3.35-9.17-.84-2.67-1.89-1.57-2v-1.57l-4.09,1.89h-3.14c-.47,0-1.57,1.88-1.57,1.88l-1.73,1.1-3-.78-.35,1.63.59,1.12a2.22,2.22,0,0,1-.77.7c-.41.18-1.29.53-1.29.53v-1.35l-.83.65-.82.7.88,1.89.24,1.06-.48.29-.7-.23-.53-1-1.3-.18-1.53.83-1.83,0v-1.88h-1.41l-.36,2.3-1.23,2.41.17,1.3.18.71s-1.18.76-1.47.47a20.73,20.73,0,0,1-1.24-1.77s.06-1-.18-1.12-2.12-1.24-2.12-1.24l-.35-2.71-2,.65-.71,1.41.3,1.54-2.06,2.35h-1.54l-1.06-.11-1.76.64-3.42-.35-1.18,2.12,2.47,4.78-1.12,1.76-3.18.36.06.94,2.71,3.54.06,2.77-.82,1.82,2.41,2.24,4.83-.06v1.59l-.87,3,.46,0a9.14,9.14,0,0,0,2.67-.63l2.51-1.73-.16-2.2,1.89-.63s1.41-2.51,2-2.51a7.22,7.22,0,0,1,1.89,0,15.22,15.22,0,0,1,2.67.78l3.14,2.36,2.52.63,1.57.31,1.73,2.52v2.51l1.88,2.67,1.1,3.15.79,3.14s2.83,2,3,2.51-.15,2.68.79,2.68,2.51.15,2.51.15l12.58,9.59s2.35,2,3.61,2,3.93-1.1,5.5-.31a24.47,24.47,0,0,1,4.24,3.45l2.05,1.42s1.25-.32.94,1.57l-.32,1.88a4.21,4.21,0,0,0,2,0,13.55,13.55,0,0,0,2-1.72l2,1.57.47.94-.47,1.57,0,1.21,3,1.88,2.2-.52,1.89.94,1.57,2.62,2.83,3.77,1.46,5.45v2.51l-1,.21-1.26.74-.1,3.24-1.68,1.16.31,2.51.95,1,2.2.21.62-2.62,2.73-2.83s1.78-.42,1.57-1.57-.94-3.35-.94-3.35l.94-1.78,1.57-1,1.57-.21h.95l.41-.21-.31-1.25-.31-1.26-.11-1.36v-.84l-2.72-1.89-2.73-.94a4.87,4.87,0,0,1-.42-2,19.06,19.06,0,0,1,.32-2.83l1.78-4.61,2-1h2.41l-1.26.63v.63h.42l1.47.11,2.51.1,1.89.21a1.81,1.81,0,0,1,.94,1.15c.21.84,0,1.05.21,1.47s0,1.05.32,1.15,1.46,1.26,2,1.47,1.46.73,1.46.73.84,1,.84,0,.1-3.45.1-3.45Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-2"
        d="M2398.63,575.28a13.93,13.93,0,0,1-.15-2l-1.58-1.57.63-1.1.63-.63v-3.77h0s2.67-2.83,3-3.78a16,16,0,0,0,.63-3.14c0-.47.94-.94,1.41-.94a.37.37,0,0,1,.2.07c.91.52,1.32,1.18,1.6,1.12,0,0,.38-.08.4-3.39h0l.16-.94-1.73-.95-1.42-1.1-.78-2,.47-1.26,1.1-1.41-.31-1.73.31-3,.79-2.05.15-.94h-1.73s.63,1.1,0,1.41,1.26.16-.62.32a6.83,6.83,0,0,0-2.52.47,4,4,0,0,0-1.1.79l-.63,1.41-2.51,3.46a10,10,0,0,1-2.67.47h-2.2l-.47.63a26.94,26.94,0,0,0-1.58,3.77v3.14l-.78,4.56v2.67s-.32,1.73-.32,2.2,2.52,1.88,2.52,1.88a4.8,4.8,0,0,1,1.57,1.42L2391,574l2.45.65,4.29.84h1.21Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2504.7,602.15l-.94-3.3-1.41-.78-.95-4.93a13.14,13.14,0,0,1-1.67-.21c-.32-.1-.84-1.15-.84-1.15s.31-1.89.31-2.2,3.36-2.83,3.36-2.83l-1.58-5.34-2.82-2.93-2.31-4.3.63-1h.15a12.08,12.08,0,0,1-1-2.29s-2.93-1.05-3.56-1.15a5.61,5.61,0,0,1-1.78-1.26l-1.47-1.15a16.71,16.71,0,0,1,.21-1.78l.42-1.26a4.92,4.92,0,0,0-.84-1.68c-.42-.31-1.46.11-1.46.11s-4.09,0-4.4-.11-4.51-1.57-4.51-1.57h-.73l.15,4.09h-1.1a34,34,0,0,1-5.5-.32l-.47.94-1.1.79.47,2.36,1.26.94a21.41,21.41,0,0,1-2.2,3.77,5.9,5.9,0,0,1-2.53,1,8.68,8.68,0,0,1-1.4,0c-2.51,0-2.88.07-3.77-.15a9.74,9.74,0,0,1-1.73-.79l.16-1.41.94-1.26.16-.63-.63-.16-3.93-.31-3.92.94-4.88,3.62s-8,7.38-9.42,7.38-3.3,1.73-3.3,1.73l-.32,2.52s-.16,1.41-1.1,1.1l-1.33-.47.19,2.1,1.7,2.69-.14,1.84-1.84,2v1.41l2.41,1.56,2,1.13.71,4.25s.42,2.27.56,2.69a29.56,29.56,0,0,1,.29,3.12l2,2.12.85,1-1,6.24,1.27.14.15-1,1.69-.15,1,2.27,8.07.57v.7s-1.7.71-1.13,1.28,2.83,2.41,2.83,2.41.71,1.41,1.27,1.27,2,.29,2-.71a3.63,3.63,0,0,0-.29-1.55l-1.41-1.7,1.7-.15,1.69.43,1.28,1.56,1.13-.43,1.56.43.28,1.27s-1.13,1,.85,1.14.43.56,2,.14l1.55-.43,1.85.29,1.41.14.43,2.12,2.55,2.83,2,.15,1.41-2.55,3,1.7.57,2.12h1.69l2.7-2.83,8.49-1,3.4-.85,3.16,3.15,1.9-.29,2.35-.63-.78-1.57-1.57-2.35V624l1.25-4.4,2.83-4.4,2.52-1.57a4.78,4.78,0,0,0,.78-1.57c0-.47-1.41-6.13-1.41-6.13Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2458.91,642.65l1.32-1.46,5.69-2.34,1.1-4.9,2.63-1.9,2-2.33,0,0-.83-.92-.43-2.12-1.41-.14-1.85-.29-1.55.43c-1.56.42,0,0-2-.14s-.85-1.14-.85-1.14l-.28-1.27-1.56-.43-1.13.43-1.28-1.56-1.69-.43-1.7.15,1.41,1.7a3.63,3.63,0,0,1,.29,1.55c0,1-1.42.57-2,.71s-1.27-1.27-1.27-1.27-2.27-1.84-2.83-2.41,1.13-1.28,1.13-1.28v-.7l-8.07-.57-1-2.27-1.7.15-.14,1-1.27-.14-.55.64-1.44.36-.18-1V618l-2.7.45.09.72a.55.55,0,0,1-.09.63,14.88,14.88,0,0,1-2,1.44s-1.35,0-1.35.26a4,4,0,0,1-.54,1.08l-1.26.9h-1.26a6.76,6.76,0,0,0-.63.72,5.53,5.53,0,0,1-1.17.81l-1.44.36s.18,1.08-.18,1.08h-2.79a6.62,6.62,0,0,0-.81,1.08c-.09.27-.54,1.26-.54,1.26l-1-.63-.72-.36-.36,1.26,1.53,1.71,1,1,.81,1.71-.27,1.17,1.62,3.41,2.25.63,2.07.81,1.17,2.25,2.7,1.08,2.78,1.71s1.8,2.16,2.16,2.16h5.22l1.62-3.87.63-1.26,5.66.27,2.07,1.26s1.17-.18,2.07-.36a11.38,11.38,0,0,1,1.89-.27c.29,0,2,.4,3.08.65Z"
        transform="translate(-2223.59 -372.99)"
      />
      <polygon
        className="cls-2"
        points="173.43 198.49 173.32 198.68 173.43 198.49 173.43 198.49"
      />
      <path
        className="cls-2"
        d="M2440.46,580.34l.16-.12Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2439.39,581.09l.1-.06Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2439.79,580.82l.08-.05Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2440.12,580.59l.14-.1Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2441.93,579.18l.18-.14Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2441.55,579.49l.18-.15Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2440.81,580.07l.17-.13Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2441.18,579.78l.17-.13Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2438.22,581.7h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2432.37,586.72h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2432.71,586.84h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2433,587l.06,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2438.39,581.65l.08,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2439.1,581.28l.1-.06Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2438.83,581.43l.1,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2438.6,581.56l.09,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2450.69,622.43a.47.47,0,0,0,.09.12A.47.47,0,0,1,2450.69,622.43Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2450.78,622.55a.68.68,0,0,0,.12.12A.68.68,0,0,1,2450.78,622.55Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2450.68,622.2a.15.15,0,0,0,0,.07A.15.15,0,0,1,2450.68,622.2Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2450.77,622l.06-.07Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2450.74,622.08a.16.16,0,0,0,0,.07A.16.16,0,0,1,2450.74,622.08Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2450.66,622.32a.19.19,0,0,0,0,.07A.19.19,0,0,1,2450.66,622.32Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2451.07,622.82l-.13-.12Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2451.26,623l.22.19h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2451.26,623l-.17-.15Z"
        transform="translate(-2223.59 -372.99)"
      />
      <a href="/germany">
        <path
          className="cls-1 germany active"
          d="M2431.72,642.84l-2.7-1.08-1.17-2.25-2.07-.81-2.25-.63-1.62-3.41.27-1.17-.81-1.71-1-1-1.53-1.71.36-1.26.72.36,1,.63s.45-1,.54-1.26a6.62,6.62,0,0,1,.81-1.08h2.79c.36,0,.18-1.08.18-1.08l1.44-.36a5.53,5.53,0,0,0,1.17-.81,6.76,6.76,0,0,1,.63-.72h1.26l1.26-.9a4,4,0,0,0,.54-1.08c0-.26,1.35-.26,1.35-.26a14.88,14.88,0,0,0,2-1.44.55.55,0,0,0,.09-.63l-.09-.72,2.7-.45v.72l.18,1,1.44-.36.55-.64,1-6.24-.85-1-2-2.12a29.56,29.56,0,0,0-.29-3.12c-.14-.42-.56-2.69-.56-2.69l-.71-4.25-2-1.13-2.41-1.56v-1.41l1.84-2,.14-1.84-1.7-2.69-.19-2.1-1.34-.48s-1.41-.94-1.57-1.41.63-.79-1.26-1.89a10.19,10.19,0,0,0-2.67-1.25l-4.09-.79-1.25-1.89v-.62l-1.1.78-1.89,2.52s-2.83,0-3.14.47-.94,1.57-.94,1.57l-1.58,1.73-2.35-.16s-1.89-.63-1.89-1.1a8.41,8.41,0,0,1,.47-1.73l.32-1.88v-1.26a9,9,0,0,1-1.57.31,11.88,11.88,0,0,0-1.42.16h-3.46a.61.61,0,0,1-.62-.63c0-.63-.16-2.67-.16-2.67l-1.62-.94h-1.21l-4.29-.84L2391,574l0,.7,2.36,3.93.63.94-1.73,1.42,1.26.78.63.95-.32.78-.63.32.63.62q.61.21,1.26.48c.5.2,1,.41,1.41.62l1.57,1,1.42,2.83h-2.52l-.78-.95-1.89-.78s1.1-.32-.63-.32-1.57-.78-1.72,0l-.16.79-.94,2.36s-1.89-1.58-1.89,0a1.54,1.54,0,0,1-1.57,1.57l-.32-2.67-2.35-.48-2.52.48s-.94.78-.94,1.25-1.41.16,0,1.26,1.89,1.41,1.89,1.41L2381,594.3l0,.1-.1,1.26.94,1-1.47,4.19s-2.82-.31-2.72.42a6.24,6.24,0,0,0,.63,1.68l2.3.42-1,3.14-1.57,1.89-.11,1.25-5.45.21.84,3.15,1.47,2.62-1.05,2.3-1.57,3.14s.84.21.84.63v1.57s-.63,1.16-.11,1.36.42,1.79.42,1.79.42,1.15.73,1.25a14.79,14.79,0,0,1,1.47.84l-.31.63-2,1.78.83,2.72,1.79,1.16-2.2,3.56s2.82,3.46,3.24,3.56,11.74,2.41,11.74,2.41l-3.36,5.24v5.86c0,.53-.73,3.46-.73,3.46V660l1.15.42a14.94,14.94,0,0,0,2.1.21l4.71.1-.52-1.78.63-.63,3.24.42s3.46,2.2,4.09,2.52c.11,0,.28.15.5.28l-.19-1.23,2.68-.47a11.6,11.6,0,0,0,1.1,1.42,15.49,15.49,0,0,0,2.2,1.41l.31-2,4.87.15.63,1.58,5.81-1.26,3.78-1.73,1.1-1.73h3.45l2.52,1.57,1.73-1.41-1.42-2-2.67-2.68.79-1.88,3-1.1-.16-2.52,1.26-.47.63.32,1.41.47.69-3.71Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-1"
        d="M2451.1,621.72l-.11.09Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2451,621.84l-.08.08Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2451.12,621.7l.15-.09Z"
        transform="translate(-2223.59 -372.99)"
      />
      <a href="/switzerland ">
        <path
          className="cls-1 switzerland active"
          d="M2408.38,668.94l-1-1.26-2.2.94-2.83-.78a10.45,10.45,0,0,1-1.72-1.89,1.73,1.73,0,0,1,.15-1.1l-.31-2.51-.13-.82c-.22-.13-.39-.23-.5-.28-.63-.32-4.09-2.52-4.09-2.52l-3.24-.42-.63.63.52,1.78-4.71-.1a14.94,14.94,0,0,1-2.1-.21l-1.15-.42-1,1.36-.1,1.26-3.14-1.36-.42.62.52,1.16-3.56,4.71-4.3,5-1.67,4.5,2.09.11.53-2.62,4.4-.94.83,2.83.63,3.24.34.37,3.28.33,1.76-.64,1.06.11h1.54l2.06-2.35-.3-1.54.71-1.41,2-.65.35,2.71s1.89,1.12,2.12,1.24.18,1.12.18,1.12a20.73,20.73,0,0,0,1.24,1.77c.29.29,1.47-.47,1.47-.47l-.18-.71-.17-1.3,1.23-2.41.36-2.3h1.41v1.88l1.83,0,1.53-.83,1.3.18.53,1,.7.23.48-.29-.24-1.06-.88-1.89.82-.7.83-.65v1.35s.88-.35,1.29-.53a2.22,2.22,0,0,0,.77-.7l-.59-1.12Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <a href="/netherlands">
        <path
          className="cls-1 netherlands active"
          d="M2373,621.74c0-.42-.84-.63-.84-.63l1.57-3.14,1.05-2.3-1.47-2.62-.84-3.15,5.45-.21.11-1.25,1.57-1.89,1-3.14-2.3-.42a6.24,6.24,0,0,1-.63-1.68c-.1-.73,2.72-.42,2.72-.42l1.47-4.19-.94-1,.1-1.26,0-.1,2.09-1.11-2.68,1.42-1.72-2.36-3.46.32-2.52.15h-.78l-2,1.42-2.05,1.41v1.57l1.1,1,1.26.15.31.63-.31,3.14-.16.79L2366,605l-.79-2.36.63-2,.79-.31A1.72,1.72,0,0,1,2366,599a4.75,4.75,0,0,0-.32-1.57h-1.73l-.78,2.67-.47,3.3-.63,2s-1.1,2.67-1.89,2.83-2,.31-2,.31l.63.79,2,1.41a.71.71,0,0,1,.47.63,1.32,1.32,0,0,1-.94,1.26c-.63.16-2.83,1.1-2.83,1.1l-1.73-.79-.94-.94s-.79-.78-1.26-.16a2,2,0,0,0-.47,1.1l1.1.48,1.26.47,1.57.47h.94l2.05.47v.63c0,.47.47.78,0,.94l-.48.16-.94-.32a1,1,0,0,0-1.1-.94c-1.32,0-1.78,0-2.67,0a4.85,4.85,0,0,0-1.57.06,3.48,3.48,0,0,0-.68.26l1.78,1.88,3.25.73,3.77-.31v-2.2l3.35-.21,1,1.05,2.93.1.84.74,1.47,1.36-.84,3.46,1.15.73,1.68.06Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <line className="cls-1" x1="128.73" y1="242.37" x2="128.73" y2="242.37" />
      <a href="/belgium">
        <path
          className="cls-1 belgium active"
          d="M2375.8,634.84l-1.79-1.16-.83-2.72,2-1.78.31-.63a14.79,14.79,0,0,0-1.47-.84c-.31-.1-.73-1.25-.73-1.25s.11-1.58-.42-1.79.11-1.36.11-1.36v-.25l-1.68-.06-1.15-.73.84-3.46-1.47-1.36-.84-.74-2.93-.1-1-1.05-3.35.21V618l-3.77.31-3.25-.73-1.78-1.88c-1.92.71-3.84,1.45-5.76,2.2l-.86.33,1.38,3.86,2.51.41,1.16,3.15,6.28,2,1.36,4.5,1.79.42,3-1.88.21,3a22,22,0,0,0,3.56,2.52c1,.31,1,1.26,3.46,1.36.89,0,2.15.06,3.41.08Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-2"
        d="M2393,698.55l-.12.18Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2392.21,699.86v0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2392.35,699.61l0,.1Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2393.09,698.47l.08-.1h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2392.26,699.76l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2392.71,699l-.08.12Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2392.87,698.8l-.14.21Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2392.62,699.17a1.93,1.93,0,0,1-.13.21Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2392.47,699.42l-.09.15Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2392,676.81l.05,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2392.21,676.94l.06,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2392.11,676.88h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2347.27,617.63l.13-.07Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2347.53,617.48l.06,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2347.13,617.71l.09-.05Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2347.74,617.37h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2346.78,617.87l.07,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2345.93,618.2l.26-.12Z"
        transform="translate(-2223.59 -372.99)"
      />
      <a href="/france">
        <path
          className="cls-1 france active"
          d="M2383.34,662.6l.1-1.26,1-1.36v-1.05s.73-2.93.73-3.46v-5.86l3.36-5.24s-11.32-2.31-11.74-2.41-3.24-3.56-3.24-3.56l.47-.76c-1.26,0-2.52,0-3.41-.08-2.51-.1-2.51-1-3.46-1.36a22,22,0,0,1-3.56-2.52l-.21-3-3,1.88-1.79-.42-1.36-4.5-6.28-2-1.16-3.15-2.51-.41-1.38-3.86a26.21,26.21,0,0,1-3.39,1.39c-.47,0-2.82.32-2.82.32l-1.58,8.48-10.84,6.29-.63,1.26-1.88.94-8.33-.94-1.1-2.83-.79-1.26-2.67-.31-1.88.78,1.72,5.34s2.36,6.45.16,6.45-10.37.47-10.37.47l-2.51-4.09-6.6.16H2289a7.55,7.55,0,0,1-1.57,1.41,9.54,9.54,0,0,0-1.89,1.89l3.62,1.89-2.05,1.41,12,6.76,5.34,5.18-.47,5.35,6.91,7.22,1.42,9-1.89,7.23-7.86,17,1.26,2,1.89.16.31,1.89,12.57,5.5h4.4l1.1-.63,2.52.16,6.44,2.82s-.63,1.58.31,1.89,3,.94,3,.94l3.46-.78,1.88,1.88,4.48-.89c-.59-.64-1.34-1.49-1.34-1.78a30.16,30.16,0,0,1,.79-3.14l-.79-1.57,2.68-4.25a1.88,1.88,0,0,0,1.88.32,55.37,55.37,0,0,0,4.56-3.46s3.77,1.89,4.24,2a4.77,4.77,0,0,1,1.26,1.1l3-2,1.42.63-.47.94-.48.63,1.1.32s.95.62,1.1,1.1a10.62,10.62,0,0,0,1.89,1.88l4.24.16,4.09-.47.78-1.73,2.83-2.52s1,.63,1.57-.15,1.58-2,1.58-2a17.39,17.39,0,0,1,2.84-.75l.87-3V700.5l-4.83.06-2.41-2.24.82-1.82-.06-2.77-2.71-3.54-.06-.94,3.18-.36,1.12-1.76-2.47-4.78,1.18-2.12,3.42.35-3.28-.33-.34-.37-.63-3.24-.83-2.83-4.4.94-.53,2.62-2.09-.11,1.67-4.5,4.3-5,3.56-4.71-.52-1.16.42-.62Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-1"
        d="M2347,617.78l.07,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2346.26,618.06l.37-.15Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2346.89,617.83l.06,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <a href="/spain">
        <path
          className="cls-1 spain active"
          d="M2346.07,719.9l-4.48.89-1.88-1.88-3.46.78s-2-.63-3-.94-.31-1.89-.31-1.89l-6.44-2.82-2.52-.16-1.1.63h-4.4l-12.57-5.5-.31-1.89-1.89-.16-1.26-2-6-.16s-2.2-1.57-3.46-1.57-3.14.16-3.77.16a8.9,8.9,0,0,1-2.35-.94,13.45,13.45,0,0,0-5.5-1.42,41,41,0,0,1-5.82-.31c-.94-.16-6.91-3.62-6.91-3.62s-6.44-1.1-7.07-1.1-3.77.32-4.72,0a41.52,41.52,0,0,1-4.24-2.35s-.79-1.1-1.41-1-6.76,4.09-6.76,4.09l-7.54,2,2,6.92.31,2.35s-1.73,1.42-1.73,1.89v3l0,.74.21,0,4.56-2.67,2,.16-.78,1.73.15,1.57,4.56,1.25,6.13-.31,3.61.63.47,1.73,1.26,1.57v3.93l-6.76,2.83.48,8.32-3.78,1.42,1.1,1.88-1.88,4.72-3.46-.79-.16,2.2.95,3.93.78.47-3.3,6.13,1.26,2.67s1.26.94,1.26,1.57-5.5,5.66-5.5,5.66l-1.57.94,1.37,3.92,3-.3,4.24,2.67,1.41,3s-1.41,3.78-.31,4.56,6.76,6.13,6.76,6.13l4.87-4.09,4.55.48,2.52-2.52,9.58.94s4.4,1.1,4.87,1.1,3,.32,3.46,0,1.42-.78,1.42-.78a9.28,9.28,0,0,0,2.2,1.1c.47,0,6.75-7.86,6.75-7.86h8l1.41-1.57s.79-6.91,1.57-7.07,8-3,8-3-2.36-7.38-2.83-7.85a13.39,13.39,0,0,1-1.26-2.83l11.79-14.62,16.34-6s3.93-2.67,4.4-3.14,2.67-2.67,2.83-3.77.63-3.14.63-3.14-.33-.33-.71-.74Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-1"
        d="M2344.76,718.24l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2345,718.6l.06.07Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2344.85,718.4a.16.16,0,0,0,0,.07A.16.16,0,0,1,2344.85,718.4Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2345.15,718.83l0,.06Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2345.64,719.42l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2302.46,704.92"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2349.66,709.26l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2349.45,709.39l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2349.92,709.08l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2350.2,708.89h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2350.82,708.43l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2350.49,708.67l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-1"
        d="M2345.86,719.67l0,0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2252.32,782.13l.35.32Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2252,781.79l.27.25Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2251.51,781.39l.34.31Z"
        transform="translate(-2223.59 -372.99)"
      />
      <a href="/portugal">
        <path
          className="cls-2 portugal active"
          d="M2239.14,765.26l1.57-.94s5.5-5,5.5-5.66-1.26-1.57-1.26-1.57l-1.26-2.67,3.3-6.13-.78-.47-.95-3.93.16-2.2,3.46.79,1.88-4.72-1.1-1.88,3.78-1.42-.48-8.32,6.76-2.83v-3.93l-1.26-1.57-.47-1.73-3.61-.63-6.13.31-4.56-1.25-.15-1.57.78-1.73-2-.16-4.56,2.67-.21,0-.89,12-8.48,14.93h-1.42s-2.2,2-2.2,2.83-.31,3.77-.31,3.77l-.16,1.1,6.44-2.51-2.51,3.14-2.52,1.73.63.78a1.07,1.07,0,0,0,1.26.48c.79-.32,4.24-.95,4.24-.95l-2.83,3.15s.16,5,.16,5.65-3.77,7.07-3.77,7.07l.16,2.2h1.1l1.57-1.25,2.36.15,2,1,3,1.73,2.52-1.1,2.51-.32,3.15-.31-3,.3Z"
          transform="translate(-2223.59 -372.99)"
        />
      </a>
      <path
        className="cls-2"
        d="M2250.82,780.76l.23.21Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2253.11,782.86l.28.26Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2252.68,782.46l.35.32Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2251.17,781.07l.33.31Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2249.21,779.35l-.14-.11Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2248.88,779.09l.14.11Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2253.46,783.18l.67.63h0Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2250.1,780.12l.62.55Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2249.81,779.87l.21.17Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2249.27,779.4a1.68,1.68,0,0,1,.21.18A1.68,1.68,0,0,0,2249.27,779.4Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2249.49,779.58l.24.22Z"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2465.5,574.5"
        transform="translate(-2223.59 -372.99)"
      />
      <path
        className="cls-2"
        d="M2466.5,575.5"
        transform="translate(-2223.59 -372.99)"
      />
    </svg>
  )
}

export default Svg
